import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import { Typography } from '../../../Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../../../context/ViewContext/ViewContext.js';
import { ReactComponent as SvgError } from '../../../../shared/assets/error.js';
import { ReactComponent as SvgCheck } from '../../../../shared/assets/check.js';
import '../../../../utils/constants/colors.js';
import '../../../../shared/consts/index.js';
import '../../../../context/DynamicContext/DynamicContext.js';
import '../../../ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import { classNames } from '../../../../utils/functions/classNames/classNames.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../Transition/ZoomTransition/ZoomTransition.js';
import '../../../Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../Transition/OpacityTransition/OpacityTransition.js';
import '../../../../config/ApiEndpoint.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../../IconButton/IconButton.js';
import { Spinner } from '../../../IconWithSpinner/Spinner/Spinner.js';

const Network = ({ iconUrl, isActive, networkName, className, checkboxClassName = '', isChanging, }) => (jsxs("div", Object.assign({ className: classNames('network', className) }, { children: [jsxs("div", Object.assign({ className: 'network__title-container' }, { children: [iconUrl ? (jsx("img", { src: iconUrl, className: 'network__title-icon', alt: `${networkName} icon` })) : (jsx(SvgError, {})), jsx(Typography, Object.assign({ variant: 'button_primary', className: 'network__title-copy', as: 'span', weight: 'medium' }, { children: networkName }))] })), jsxs("div", Object.assign({ className: classNames('network__status-container', {
                'network__status-container--active': isActive,
            }, checkboxClassName), "data-testid": 'single-network-checkbox' }, { children: [isActive && jsx(SvgCheck, { className: 'network__status-icon' }), isChanging && (jsx(Spinner, { className: 'network__status-spinner-icon', size: 12 }))] }))] })));

export { Network };
